const url = {
    apiGinUrl: window._env_?.REACT_APP_API_URL,
    pricingapiurl: window._env_?.PRICING_API_URL,
    packagingapiurl: window._env_?.PACKAGING_API_URL,
  sampleManagementApiUrl: process.env.REACT_APP_SAMPLE_MANAGEMENT_API_URL,
  blendSheetApiUrl: process.env.REACT_APP_BLEND_SHEET_API_URL,
  //packagingapiurlCalender: process.env.CCLCALENDER_API_URL || window._env_.CCLCALENDER_API_URL, --unwanted change added to the production release branch
};

export default url;